export default __webpack_public_path__ + "static/media/a012-3.f3fa8e3f.svg";